'use strict';

import React,{ Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from "lodash";
import { getReports } from '../../../../../jsx/actions/reportAction';
import { getPaygClients } from '../../../../../jsx/actions/clientAction';
import { getPayments } from '../../../../../jsx/actions/paymentAction';
import { fetchSubscriptions } from '../../../../../jsx/actions/subscriptionAction';

import Moment from 'moment';
    //CurveChartHighchartConsoDay = require('../../../global/chart/highchart/curveChartConsoDay.jsx'),
    //DialogBoxChart = require('../../../global/mainContent/dialogBoxForNewChart.jsx'),
    //MiniChart = require('../../../global/data/miniChart.jsx'),
import MicroChart from '../../../global/data/microChart.jsx';
import MicroList from '../../../global/data/microList.jsx';
import MiniList from '../../../global/data/miniList.jsx';
import MiniListImg from '../../../global/data/miniListImage.jsx';
import MiniTriple from '../../../global/data/miniTripleValue.jsx';
import { SalesPie, SalesStackBar, AgentsStackBar } from '../../../global/SaleStats';
import Spin from '../../commonModules/interface/Spin';
import { Grid, Box, Card, Typography } from '@material-ui/core';
var $ = require('jquery');

class mainDashboard extends Component{
    state = {
        //Initiate Time for the chart
        timeFrom: Moment().add(-1, 'days').utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        timeTo: Moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        timeFromForAnalysis: Moment().add(-7, 'days').utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        timeFromForAverageConso: Moment().add(-7, 'days').utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        timeFromCompareTo: Moment().add(-7, 'days').utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        seriesConsoDay: '{}',
        NbOfPeople: 0.0,
        LastDayProduction: 0.0,
        TotalProduction: 0.0,
        ActualPower: 0.0,
        LastSellsTypeList: [
            0, 0, 0
        ],
        LastSellsNameList: ["","",""],
        LastSellsList: [],

        CAweek: 0,
        CAmonth: 0,
        CAyear: 0,

        ConnectedBox: 0,
        ConnectedBox2G: 0,
        ConnectedBoxLora: 0,

        PaymentOK: 0,
        Payment1Week: 0,
        Payment3Weeks: 0,

        InstallationWeek: 0,
        InstallationMonth: 0,
        InstallationYear: 0,

        salesList: [],
        agentsList: [],
    };
    
    componentDidMount = async () => {
        // this.getSalesList()
        this.getAgentsList()
        if(isEmpty(this.props.SUBSCRIPTIONS)){
            this.props.fetchSubscriptions()
        }
        if(!this.props.PAYMENTS){
            this.props.getPayments()
        }
        if(!this.props.STATE.paygClients.fetched){
        // if(!this.props.CLIENTS){
           this.props.getClients()
        }
        // this.props.showNotif("notif activated", "warning")

        Promise.all([
           // this.getInstallationStateInfo(),
            this.getPaymentsInfo(),
            this.getNbOfImpactedPeople(),
            this.getEnergyInfo(),
            //this.getLastSalesInfo(),
          //  this.getSalesPerType(),
          //  this.getBoxConnexionInfo()
        ])
    }

    
    getAgentsList = async () => {
        try {
            const response = await fetch('/dashboard/agent/list',{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            }); 
            
            const res = await response.json()
            console.log({res})

            if(!res.error){
                this.setState({
                    agentsList : res.agentsList
                })
            } else {
                console.log('====================================');
                console.log("getAgentsList, ", res.error);
                console.log('====================================');
            }
            
        } catch (error) {
            console.log('====================================');
            console.log("getAgentsList, catch ", error);
            console.log('====================================');
            
        }
    }

    getPaymentsInfo = async () => {
    
        var methodNameInit = 'Payment Global Info';
        const { PAYMENTS } = this.props
        
        console.log('[INFO], ',methodNameInit,' reception front des données: ', PAYMENTS);
        var CAweek = 0;
        var CAmonth = 0;
        var CAyear = 0;

        try {
            Object.keys(PAYMENTS).map(ID =>{

                if ( Moment(PAYMENTS[ID].timePayment) >= Moment().add('-7','days')){
                    CAweek = CAweek + PAYMENTS[ID].money;
                }
                if ( Moment(PAYMENTS[ID].timePayment) >= Moment().add('-31','days')){
                    CAmonth = CAmonth + PAYMENTS[ID].money;
                }
                CAyear = CAyear + PAYMENTS[ID].money;
            })
            
            
        } catch (e) {
            console.log('[ERROR], ', methodNameInit, ',Parsing data from serveur ');
            console.log(e); // on transfère l'objet de l'exception à une méthode
        }

        this.setState({CAweek: CAweek+ ' FCFA', CAmonth: CAmonth+ ' FCFA', CAyear: CAyear+ ' FCFA'});
    }
    getNbOfImpactedPeople = async () => {
        //Requête pour récupérer la valeur des Consommation en veille
        var methodName1 = 'Impact Social';
        var urlImpact = "/family/global/info";

        this.serverRequest5 = $.get(urlImpact, function(result) {
            console.log('[INFO],' + methodName1 + '  reception front des données de ConsumptionOff: ', result);
            var NbOfPeople = 0;
            try {
                NbOfPeople = result.NbOfPeople;
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName1, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
            }

            this.setState({NbOfPeople: NbOfPeople});
        }.bind(this));
    }
    getEnergyInfo = async () =>{ //Requête pour récupérer la moyenne des consommation jour en Wh et en Euros
        var methodName20 = 'Info Energy';
        var url20 = "/solar/global/info";

        this.serverRequest20 = $.get(url20, function(result) {
            console.log('[INFO],' + methodName20 + '  reception front des données de : ',result);
            var LastDayProduction = 1;
            var TotalProduction = 1;
            var ActualPower = 1;
            try {
                LastDayProduction = result.LastDayProduction;
                TotalProduction = result.TotalProduction;
                ActualPower = result.ActualPower;
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName20, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
            }
            this.setState({LastDayProduction: LastDayProduction.toFixed(2), TotalProduction: TotalProduction.toFixed(2), ActualPower: ActualPower.toFixed(2)});
        }.bind(this));
    }

    render () {
        console.log('[INFO], render fonction card');

        return (
            <Box >
                <Typography variant="h6">Tableau de Bord</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                        <MiniList 
                            graphName="Recette" 
                            value1={this.state.CAweek} 
                            value2={this.state.CAmonth} 
                            value3={this.state.CAyear}
                            ClickOnMenu={() => this.props.ClickOnMenu("Paiement", {show: "Dashboard"})}
                        />
                    </Grid>
                    
                    <Grid item xs={12} md={9} >
                        <Card>
                            {!isEmpty(this.state.agentsList) && !isEmpty(this.props.SUBSCRIPTIONS) &&
                                <SalesPie {...this.state} {...this.props}/>
                            }
                            {isEmpty(this.state.agentsList) || isEmpty(this.props.SUBSCRIPTIONS) &&
                                <div style={{height: "400px" , backgroundColor: "white", margin: "auto"}}>
                                    <Spin noOverlay /> 
                                </div>
                            }
                        </Card>
                    </Grid>
                    
                    <Grid item xs={12}>
                        <Card>
                            <Box p={2}>
                            {!isEmpty(this.state.agentsList) && ! isEmpty(this.props.SUBSCRIPTIONS) &&
                                <SalesStackBar {...this.state} {...this.props}/>
                            }
                            {isEmpty(this.state.agentsList) || isEmpty(this.props.SUBSCRIPTIONS) &&
                                <div style={{height: "400px" , backgroundColor: "white", margin: "auto"}}>
                                    <Spin noOverlay /> 
                                </div>
                            }
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <MicroChart graphName="Production Totale" unit="kWh" Value={this.state.TotalProduction}/>
                    <MicroChart graphName="Production Dernier Jour" unit="kWh" Value={this.state.LastDayProduction}/>
                    <MicroChart graphName="Production en direct" unit="W" Value={this.state.ActualPower}/>
                    <MicroChart graphName="Nombre de Personnes Impactées" unit="habitants" Value={this.state.NbOfPeople}/>
                </Grid>
                <Grid container spacing={2}>
                <Grid item xs={12}>
                        
                    </Grid>
                </Grid>
                
            </Box>
        );
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        REPORTS: state.reports,
        CLIENTS: state.clients,
        STATE: state.inventory.requestState,
        PAYMENTS: state.payments,
        SUBSCRIPTIONS: state.subscriptions,
    }
}

function mapDispatchToProps(dispatch){  
    return bindActionCreators({
        getReports,
        getClients: getPaygClients,
        getPayments,
        fetchSubscriptions
    }, dispatch)
}

const App = connect(mapStateToProps, mapDispatchToProps)(mainDashboard);

export default App;
